import ApiService from '../util/api';
import * as GuestActionTypes from './types/GuestActionTypes';

// external actions
import { hideModal } from './ModalActions';
import * as NotificationActions from './NotificationActions';
import * as GuestActions from './GuestActions';

function setBusy(bool) {
  return {
    type: GuestActionTypes.SET_BUSY,
    payload: { busy: bool }
  };
}
export function resetMapping() {
  return { type: GuestActionTypes.RESET_MAPPING };
}

// Actions for mapping
export function addExtraField(fieldName) {
  return {
    type: GuestActionTypes.ADD_EXTRA_FIELD,
    payload: { fieldName }
  };
}
export function mapColumns(userCol, zolaCol) {
  return {
    type: GuestActionTypes.MAP_COLUMNS,
    payload: { userCol, zolaCol }
  };
}
export function unmapColumns(userCol, zolaCol) {
  return {
    type: GuestActionTypes.UNMAP_COLUMNS,
    payload: { userCol, zolaCol }
  };
}
export function receiveMappingErrors(summaries, errors) {
  return {
    type: GuestActionTypes.RECEIVE_MAPPING_ERRORS,
    payload: { summaries, errors }
  };
}

// Actions for sending the field mapping
export function completeMapping() {
  return { type: GuestActionTypes.MAPPING_COMPLETE };
}
function clearMappingErrors() {
  return { type: GuestActionTypes.CLEAR_MAPPING_ERRORS };
}
function handleMappingErrors(errors, summaries) {
  return dispatch => {
    dispatch(receiveMappingErrors(summaries, errors))
    dispatch(setBusy(false));
  }
}
function handleMappingSuccess(summaries) {
  const text = summaries.reduce((acc, summaryText, i, arr) => (i === arr.length - 1)
    ? acc + summaryText
    : `${acc + summaryText}\n\u2022\n` // insert space & bullets in between lines of messages
    , '');
  return dispatch => {
    dispatch(NotificationActions.confirmation({
      message: text,
      autoDismiss: 10
    }));
    dispatch(GuestActions.fetchGuestList());
    dispatch(completeMapping());
  };
}
function handleMappingResponse(data) {
  const { errors, results } = data;
  const { summaries } = results;
  return dispatch => (errors.length > 0)
    ? dispatch(handleMappingErrors(errors, summaries))
    : dispatch(handleMappingSuccess(summaries));
}
export function sendFieldMap(token, map) {
  return (dispatch) => {
    dispatch(clearMappingErrors());
    dispatch(setBusy(true));
    return fetch('/web-api/v1/guestgroup/import/field-map',
      {
        credentials: 'same-origin',
        headers: {
          'Content-type': 'application/json'
        },
        method: 'POST',
        body: JSON.stringify({ token, map }),
      })
      .then(ApiService.handleErrors)
      .then(response => response.json())
      .then(json => dispatch(handleMappingResponse(json)))
  };
}

// Actions for sending the CSV
function startMapping() {
  return {
    type: GuestActionTypes.MAPPING_STARTED,
  };
}
export function uploadComplete() {
  return dispatch => {
    dispatch(startMapping());
    dispatch(hideModal());
  };
}
export function receiveUploadErrors(uploadErrors) {
  return {
    type: GuestActionTypes.RECEIVE_UPLOAD_ERRORS,
    payload: { uploadErrors }
  };
}
export function clearUploadErrors() {
  return {
    type: GuestActionTypes.CLEAR_UPLOAD_ERRORS,
  }
}

function receiveCsvFields(fields, token) {
  const {
    required_fields: requiredFields,
    user_fields: userFields,
    zola_display_fields: zolaDisplayFields,
    zola_additional_fields: zolaExtraFields,
  } = fields;
  return {
    type: GuestActionTypes.RECEIVE_CSV_FIELDS,
    payload: { requiredFields, token, userFields, zolaDisplayFields, zolaExtraFields }
  };
}
function handleUploadResponse(data) {
  const hasErrors = Object.prototype.hasOwnProperty.call(data, 'errors');
  const hasResults = Object.prototype.hasOwnProperty.call(data, 'results');
  const {
    errors,
    token,
    fields,
    results
  } = data;

  if (hasErrors && errors.length > 0) return dispatch => dispatch(receiveUploadErrors(errors));
  if (hasResults && (results.summaries !== undefined)) return dispatch => {
    dispatch(handleMappingSuccess(results.summaries));
    dispatch(hideModal());
  }
  return dispatch => dispatch(receiveCsvFields(fields, token));
}
export function sendCsv(file) {
  return (dispatch) => {
    const formData = new FormData();
    formData.append('attachment', file.files[0], file.name);
    dispatch(setBusy(true));

    return fetch('/web-api/v1/guestgroup/import/csv-fields',
      {
        credentials: 'same-origin',
        method: 'POST',
        body: formData,
      })
      .then(ApiService.handleErrors)
      .then(response => response.json())
      .then(json => dispatch(handleUploadResponse(json.data)));
  };
}


// WEBPACK FOOTER //
// ./src/actions/GuestImportActions.js